import { Text } from '@/ui-kit'

export const MissionsListEmptyState = () => {
  return (
    <div className="m-auto mt-8 max-w-[350px] rounded-xl bg-[var(--color-gray-100)] p-6">
      <Text>{'No missions available at the moment.'}</Text>
    </div>
  )
}
